<template>
  <div :class="variantClass" class="!w-full px-3 py-2 rounded-md border flex items-start gap-x-3">
    <div class="w-12 h-12 flex justify-center items-center">
      <faInfoCircle class="w-9 fill-white" />
    </div>
    <slot>
      <span v-if="text" class="pt-1 flex-1 text-xs text-white text-justify">
        <p v-if="Array.isArray(text)">
          <span v-for="item in text" :key="item.key">{{ $t(item.key, { ...item.params }) }}</span>
        </p>
        <span v-else-if="typeof text === 'object'">
          {{ textRef }}
        </span>
        <span v-else>
          {{ $t(text) }}
        </span>
      </span>
    </slot>
  </div>
</template>

<script setup>
import faInfoCircle from '@/assets/icons/faInfoCircle.svg?component'
import { useFormStore } from '@/stores/form'
import lodashGet from 'lodash/get'
import { computed } from 'vue'

const props = defineProps({
  text: {
    type: [String, Array, Object]
  },
  variant: {
    type: String,
    default: () => 'info'
  }
})

const formStore = useFormStore()

const variants = {
  primary: 'border-primary bg-primary',
  info: 'border-sky-500 bg-sky-400',
  warning: 'border-yellow-500 bg-yellow-400',
  danger: 'border-red-500 bg-red-400',
  success: 'border-emerald-500 bg-emerald-400'
}
const variantClass = computed(() => variants[props.variant])

const textRef = computed(() => {
  return lodashGet(formStore.extraMap, props.text?.ref)
})
</script>

<style lang="scss" scoped></style>
